import Navbar from '../components/layout/NavbarComponent.vue';
import FooterComponent from '../components/layout/FooterComponent.vue';

export default {
    name: 'App',
    components: {
        Navbar,
        FooterComponent,
    },
    data() {
        let dataList = [[], []];

        return {
            parsedData: dataList,
            currentView: "FederalView",
            componentKey: 0,
        }
    }
}